import type { ReactElement, ReactNode } from 'react';

type Props = {
  title: string;
  href: string;
  children: ReactNode;
};

function SocialButton({ title, href, children }: Props): ReactElement {
  return (
    <li>
      <a
        target="_blank"
        title={`Opens Purple Carrot ${title} on a new window`}
        rel="noreferrer"
        href={href}
      >
        {children}
      </a>
    </li>
  );
}

export default SocialButton;
